<template>
  <v-form v-model="valid[0]" lazy-validation ref="form0">
    <v-row dense>
      <v-col cols="3" sm="2" v-if="contact.id">
        <v-text-field
          dense
          filled
          v-model="contact.id"
          :label="$t('personnePhysique.detail.form.contact.id')"
          readonly
        />
      </v-col>
      <v-col>
        <v-text-field
          v-model="contact.personneMorale.raisonSociale"
          dense
          filled
          :label="$t('personnePhysique.detail.form.contact.raisonSociale')"
          readonly
          hide-details="auto"
          prepend-inner-icon="mdi-domain"
          @click="lienPersonneMorale(contact.personneMorale.id)"
          @click:prepend-inner="lienPersonneMorale(contact.personneMorale.id)"
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="3">
        <v-select
          return-object
          dense
          filled
          :items="listeTypesContact"
          v-model="contact.typeContact"
          item-text="libelle"
          :label="$t('personnePhysique.detail.form.contact.typeContact')"
          :rules="[
            obligatoireRule(),
            serveurRule(`contacts[${index}].typeContact`),
          ]"
          :readonly="readonly"
          hide-details="auto"
          :background-color="
            analyseDiff.color[`contacts[${index}].typeContact`]
          "
          :hint="analyseDiff.hint[`contacts[${index}].typeContact`]"
        >
          <template #selection="{item}">
            {{ item.libelle }}
          </template>
        </v-select>
      </v-col>
      <v-col cols="12" md="3">
        <v-select
          return-object
          dense
          filled
          :items="listeFonctions"
          v-model="contact.fonction"
          item-text="libelle"
          :label="$t('personnePhysique.detail.form.contact.fonction')"
          :rules="[
            obligatoireRule(),
            serveurRule(`contacts[${index}].fonction`),
          ]"
          :readonly="readonly"
          hide-details="auto"
          :background-color="analyseDiff.color[`contacts[${index}].fonction`]"
          :hint="analyseDiff.hint[`contacts[${index}].fonction`]"
        >
          <template #selection="{item}">
            {{ item.libelle }}
          </template>
        </v-select>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="contact.titreContact"
          dense
          filled
          :label="$t('personnePhysique.detail.form.contact.titreContact')"
          :background-color="
            analyseDiff.color[`contacts[${index}].titreContact`]
          "
          :hint="analyseDiff.hint[`contacts[${index}].titreContact`]"
          :readonly="readonly"
          hide-details="auto"
        />
      </v-col>
      <v-col cols="12" md="2">
        <v-checkbox
          dense
          v-model="contact.collaborateurMDL"
          :label="$t('personnePhysique.detail.form.contact.collaborateurMDL')"
          readonly
          hide-details
        />
      </v-col>

      <v-col cols="12" md="2">
        <v-checkbox
          v-model="contact.principal"
          dense
          :rules="[serveurRule(`contacts[${index}].principal`)]"
          :label="$t('personnePhysique.detail.form.contact.principal')"
          :background-color="analyseDiff.color[`contacts[${index}].principal`]"
          :hint="analyseDiff.hint[`contacts[${index}].principal`]"
          :readonly="readonly"
          hide-details="auto"
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12">
        <v-card>
          <v-card-title class="text-subtitle-1">
            Coordonnées
          </v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col cols="12">
                <div class="d-flex align-start">
                  <v-text-field
                    v-if="contact.mailPP"
                    :prepend-inner-icon="
                      personnephysique.confidentialiteMail &&
                      !donneesConfidentiellesVisibles
                        ? 'mdi-email-off'
                        : 'mdi-email'
                    "
                    :disabled="
                      personnephysique.confidentialiteMail &&
                        !donneesConfidentiellesVisibles
                    "
                    dense
                    filled
                    v-model="personnephysique.mailPrincipal"
                    :label="$t('personnePhysique.detail.form.contact.mail')"
                    readonly
                    hide-details="auto"
                  />
                  <v-text-field
                    v-else
                    prepend-inner-icon="mdi-email"
                    dense
                    filled
                    v-model="contact.mail"
                    :rules="[serveurRule(`contacts[${index}].mail`)]"
                    :label="$t('personnePhysique.detail.form.contact.mail')"
                    :readonly="readonly"
                    hide-details="auto"
                    :background-color="
                      analyseDiff.color[`contacts[${index}].mail`]
                    "
                    :hint="analyseDiff.hint[`contacts[${index}].mail`]"
                  />

                  <v-tooltip bottom>
                    <template #activator="{ on }">
                      <v-checkbox
                        v-on="on"
                        :readonly="readonly"
                        v-model="contact.mailPP"
                        label="De la personne physique"
                        :background-color="
                          analyseDiff.color[`contacts[${index}].mailPP`]
                        "
                        :hint="analyseDiff.hint[`contacts[${index}].mailPP`]"
                      />
                    </template>
                    <span>{{
                      'Utiliser le mail de la personne physique'
                    }}</span>
                  </v-tooltip>
                </div>
              </v-col>

              <v-col cols="12" md="6">
                <telephonesList
                  v-model="contact.telephones"
                  :donneesConfidentiellesVisibles="
                    donneesConfidentiellesVisibles
                  "
                  :delta="contact.telPP ? 1 : 0"
                  :readonly="readonly"
                  :itemPath="`contacts[${index}].telephones`"
                  :analyseDiff="analyseDiff"
                  @annulerSuppression="annulerSuppression($event)"
                >
                  <template #premier>
                    <v-list-item
                      v-if="telephonePPVisible"
                      :disabled="
                        personnephysique.confidentialiteTelephone &&
                          !donneesConfidentiellesVisibles
                      "
                    >
                      <v-list-item-icon v-if="!readonly">
                        <v-tooltip bottom>
                          <template #activator="{ on }">
                            <v-layout row>
                              <v-checkbox
                                v-on="on"
                                class="ma-0"
                                dense
                                v-model="contact.telPP"
                                hide-details="auto"
                                :background-color="
                                  analyseDiff.color[`contacts[${index}].telPP`]
                                "
                                :hint="
                                  analyseDiff.hint[`contacts[${index}].telPP`]
                                "
                              />
                            </v-layout>
                          </template>
                          <span
                            >Utiliser le numéro de téléphone de la personne
                            physique</span
                          >
                        </v-tooltip>
                      </v-list-item-icon>
                      <v-list-item-icon v-else>
                        <v-layout row>
                          <v-icon>mdi-phone</v-icon>
                        </v-layout>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title v-if="contact.telPP">
                          {{ getInternational(personnephysique.telephone) }}
                        </v-list-item-title>
                        <v-list-item-subtitle
                          >Téléphone de la personne
                          physique</v-list-item-subtitle
                        >
                      </v-list-item-content>
                      <v-list-item-icon v-if="contact.telPP">
                        <v-tooltip bottom>
                          <template #activator="{ on }">
                            <v-icon v-on="on">{{
                              personnephysique.smsAccepte
                                ? 'mdi-cellphone-message'
                                : 'mdi-cellphone-message-off'
                            }}</v-icon>
                          </template>
                          <span>{{
                            personnephysique.smsAccepte
                              ? 'SMS accepté'
                              : 'SMS refusé'
                          }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template #activator="{ on }">
                            <v-icon v-on="on">{{
                              personnephysique.confidentialiteTelephone
                                ? 'mdi-eye-off'
                                : 'mdi-eye'
                            }}</v-icon>
                          </template>
                          <span>{{
                            personnephysique.confidentialiteTelephone
                              ? 'Téléphone confidentiel'
                              : 'Téléphone public'
                          }}</span>
                        </v-tooltip>
                      </v-list-item-icon>
                    </v-list-item>
                  </template>
                </telephonesList>
              </v-col>

              <v-col cols="12" md="6">
                <adressesList
                  v-model="contact.adresses"
                  :readonly="readonly"
                  :delta="contact.adressePM ? 1 : 0"
                  :itemPath="`contacts[${index}].adresses`"
                  :analyseDiff="analyseDiff"
                  @annulerSuppression="annulerSuppression($event)"
                  :propositionAdresse="propositionAdresse"
                  :adressePropose="adressePropose"
                  :titreProposition="titreProposition"
                >
                  <template #premier>
                    <v-list-item v-if="adressePMVisible">
                      <v-list-item-icon>
                        <v-tooltip bottom v-if="!readonly">
                          <template #activator="{ on }">
                            <v-layout row>
                              <v-checkbox
                                v-on="on"
                                class="ma-0"
                                dense
                                v-model="contact.adressePM"
                                :readonly="readonly"
                                hide-details="auto"
                                :background-color="
                                  analyseDiff.color[
                                    `contacts[${index}].adressePM`
                                  ]
                                "
                                :hint="
                                  analyseDiff.hint[
                                    `contacts[${index}].adressePM`
                                  ]
                                "
                              />
                            </v-layout>
                          </template>
                          <span>Utiliser l'adresse de la personne morale</span>
                        </v-tooltip>
                        <v-layout row v-else>
                          <v-icon>mdi-home</v-icon>
                        </v-layout>
                      </v-list-item-icon>

                      <v-list-item-content>
                        <v-list-item-subtitle
                          >Adresse de la personne morale</v-list-item-subtitle
                        >
                        <v-list-item-title v-if="contact.adressePM">
                          <adresseSpan
                            v-if="adressePersonneMorale"
                            :adresse="adressePersonneMorale"
                          />
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </adressesList>
              </v-col>

              <v-col cols="12" md="6">
                <vue-tel-input-vuetify
                  enabledCountryCode="true"
                  mode="international"
                  :v-mask="getmask(contact.fax)"
                  :preferredCountries="['FR']"
                  defaultCountry="FR"
                  disabledFetchingCountry
                  type="tel"
                  dense
                  filled
                  v-model="contact.fax"
                  :rules="[serveurRule(`contacts[${index}].fax`)]"
                  :label="$t('personnePhysique.detail.form.contact.fax')"
                  :readonly="readonly"
                  :disabled="readonly"
                  hide-details="auto"
                  :background-color="
                    analyseDiff.color[`contacts[${index}].fax`]
                  "
                  :hint="analyseDiff.hint[`contacts[${index}].fax`]"
                >
                  <template v-slot:append>
                    <v-icon>
                      mdi-fax
                    </v-icon>
                  </template>
                </vue-tel-input-vuetify>
              </v-col>

              <v-col cols="12" md="6">
                <v-select
                  dense
                  filled
                  :items="[
                    { value: 'MAIL', libelle: 'Mail' },
                    { value: 'TELEPHONE', libelle: 'Téléphone' },
                  ]"
                  v-model="contact.moyenContactPrefere"
                  item-text="libelle"
                  :label="
                    $t(
                      'personnePhysique.detail.form.contact.moyenContactPrefere',
                    )
                  "
                  :readonly="readonly"
                  hide-details="auto"
                  :rules="[
                    obligatoireRule(),
                    serveurRule(`contacts[${index}].moyenContactPrefere`),
                  ]"
                  :background-color="
                    analyseDiff.color[`contacts[${index}].moyenContactPrefere`]
                  "
                  :hint="
                    analyseDiff.hint[`contacts[${index}].moyenContactPrefere`]
                  "
                >
                  <template #selection="{item}">
                    {{ item.libelle }}
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-select
          return-object
          dense
          filled
          :items="listeDivisions"
          :clearable="!readonly"
          v-model="contact.division"
          item-text="libelle"
          :label="$t('personnePhysique.detail.form.contact.service')"
          :rules="[serveurRule(`contacts[${index}].division`)]"
          :readonly="readonly"
          hide-details="auto"
          :background-color="analyseDiff.color[`contacts[${index}].division`]"
          :hint="analyseDiff.hint[`contacts[${index}].division`]"
        >
          <template #selection="{item}">
            {{ item.libelle }}
          </template>
        </v-select>
      </v-col>

      <v-col cols="12" md="6">
        <v-select
          return-object
          dense
          filled
          :items="listeRemplaceants"
          :clearable="!readonly"
          v-model="contact.remplacant"
          item-text="libelle"
          :label="$t('personnePhysique.detail.form.contact.remplacant')"
          :rules="[serveurRule(`contacts[${index}].remplacant`)]"
          :readonly="readonly"
          hide-details="auto"
          :background-color="analyseDiff.color[`contacts[${index}].remplacant`]"
          :hint="analyseDiff.hint[`contacts[${index}].remplacant`]"
          prepend-inner-icon="mdi-account-supervisor"
          @click.native="
            readonly && contact.remplacant
              ? lienPersonnePhysique(contact.remplacant.idPersonnePhysique)
              : null
          "
        >
          <template #selection="{item}">
            {{ item.libelle }}
          </template>
        </v-select>
      </v-col>

      <v-col cols="12" md="6">
        <v-select
          return-object
          multiple
          dense
          filled
          :items="listeTypesLait"
          v-model="contact.typeLait"
          item-text="libelle"
          :label="$t('personnePhysique.detail.form.contact.lait')"
          :readonly="readonly"
          :background-color="analyseDiff.color['contacts[0].typeLait']"
          hide-details="auto"
        >
          <template #selection="{item}">
            <v-chip
              small
              :color="
                analyseDiff.color[`contacts[${index}].typeLait[${item.id}]`] ||
                  'secondary'
              "
            >
              <v-avatar
                left
                v-if="
                  analyseDiff.supprime[
                    `contacts[${index}].typeLait[${item.id}]`
                  ]
                "
              >
                <v-btn
                  icon
                  @click.stop.capture="
                    annulerSuppression(
                      `contacts[${index}].typeLait[${item.id}]`,
                    )
                  "
                >
                  <v-icon color="white">undo</v-icon>
                </v-btn>
              </v-avatar>

              {{ item.libelle }}</v-chip
            >
          </template>
        </v-select>
      </v-col>

      <v-col cols="12" md="6">
        <v-menu
          ref="menuDateLimite"
          v-model="menuValidite"
          :close-on-content-click="false"
          :return-value.sync="contact.dateLimiteValidite"
          transition="scale-transition"
          :disabled="readonly"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateFormatted"
              dense
              filled
              readonly
              hide-details="auto"
              v-bind="attrs"
              v-on="on"
              prepend-inner-icon="event"
              :rules="[
                obligatoireRule(),
                serveurRule(`contacts[${index}].dateLimiteValidite`),
              ]"
              :label="
                $t('personnePhysique.detail.form.contact.dateLimiteValidite')
              "
              :background-color="
                analyseDiff.color[`contacts[${index}].dateLimiteValidite`]
              "
              :hint="analyseDiff.hint[`contacts[${index}].dateLimiteValidite`]"
            ></v-text-field>
          </template>
          <v-card flat>
            <v-date-picker
              v-model="contact.dateLimiteValidite"
              no-title
              scrollable
            />

            <v-divider />
            <v-card-actions>
              <v-btn
                text
                color="primary"
                @click="$refs.menuDateLimite.save(contact.dateLimiteValidite)"
                >OK</v-btn
              >
              <v-btn text @click="menuValidite = false">Annuler</v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-col>
    </v-row>
    <v-row dense v-if="contact.id">
      <v-col cols="12">
        <listInstancesContact :instances="contact.instances" />
      </v-col>

      <v-col cols="12">
        <footer-rgpd :form="this.contact" genre="M" />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import moment from 'moment';
import ServeurRule from '@/plugins/mixins/ServeurRule';
import ValidationRules from '@/plugins/mixins/ValidationRules';
import {
  getInternational,
  getmask,
} from '@/components/telephone/telephoneUtil.js';
import { defaultDiff } from '@/utils/diff.js';
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib/vue-tel-input-vuetify.vue';

export default {
  components: {
    VueTelInputVuetify,
  },
  mixins: [ServeurRule, ValidationRules],
  inject: ['errors'],
  props: {
    propositionAdresse: {
      type: Boolean,
      default: false,
    },
    adressePropose: {
      type: String,
      default: null,
    },
    titreProposition: {
      type: String,
      default: null,
    },
    readonly: {
      type: Boolean,
    },
    donneesConfidentiellesVisibles: {
      type: Boolean,
    },
    index: {
      type: Number,
    },
    contact: {
      type: Object,
    },
    personnephysique: {
      type: Object,
    },
    enums: {
      type: Object,
    },
    analyseDiff: {
      type: Object,
      default: defaultDiff,
    },
  },
  data() {
    return {
      valid: [true, true],
      menuValidite: null,
    };
  },
  computed: {
    telephonePPVisible() {
      return this.contact.telPP || !this.readonly;
    },
    adressePMVisible() {
      return this.contact.adressePM || !this.readonly;
    },
    adressePersonneMorale() {
      if (this.contact.adressePersonneMorale) {
        return this.contact.adressePersonneMorale;
      } else if (this.enumsContact.adressePersonneMorale) {
        return this.enumsContact.adressePersonneMorale;
      }
      return null;
    },
    enumsContact() {
      // la liste des contacts par id de personne morale
      var found = null;
      if (
        this.enums &&
        this.enums.personnesMorales &&
        this.contact &&
        this.contact.personneMorale
      ) {
        const idPM = this.contact.personneMorale.id;
        found = this.enums.personnesMorales.find(
          e => e.personneMorale === idPM,
        );
      }
      return (
        found || {
          divisions: [],
          contacts: [],
          adressePersonneMorale: null,
        }
      );
    },
    listeDivisions() {
      if (this.enumsContact.divisions.length) {
        return this.enumsContact.divisions;
      } else {
        const divisions = [];
        if (this.contact.division) divisions.push(this.contact.division);
        return divisions;
      }
    },
    listeRemplaceants() {
      if (this.enumsContact.contacts.length) {
        if (
          this.enumsContact.contacts
            .flatMap(c => c.id)
            .indexOf(this.contact.id) >= 0
        ) {
          // un contact ne peut pas être son propre remplaçant
          return this.enumsContact.contacts.filter(
            c => c.id !== this.contact.id,
          );
        }
        return this.enumsContact.contacts;
      } else {
        const contacts = [];
        if (this.contact.remplacant) {
          contacts.push(this.contact.remplacant);
        }
        return contacts;
      }
    },
    listeFonctions() {
      if (this.enums.fonctions.length) return this.enums.fonctions;
      else {
        const fonctions = [];
        if (this.contact.fonction) fonctions.push(this.contact.fonction);
        return fonctions;
      }
    },
    listeTypesContact() {
      if (this.enums.typesContact.length) return this.enums.typesContact;
      else {
        const typesContact = [];
        if (this.contact.typeContact)
          typesContact.push(this.contact.typeContact);
        return typesContact;
      }
    },
    listeTypesLait() {
      if (this.enums.typesLait.length) {
        return this.enums.typesLait;
      } else {
        var typesLait = [];
        if (this.contact.typeLait) typesLait = this.contact.typeLait;
        return typesLait;
      }
    },
    countInvalid() {
      return this.valid.reduce(
        (accumulator, currentValue) => accumulator + (currentValue ? 0 : 1),
        0,
      );
    },
    dateISO() {
      if (this.contact) return this.contact.dateLimiteValidite;
      else return null;
    },
    dateFormatted() {
      return this.formatDate(this.dateISO);
    },
  },
  watch: {
    countInvalid(newValue) {
      //mise à jour du décompte d'invalidité dans le contact, histoire de pouvoir marquer le chemin comme invalid
      this.contact.invalid = newValue;
    },
  },
  methods: {
    getmask,
    annulerSuppression(path) {
      this.$emit('annulerSuppression', path);
    },
    validate() {
      return this.$refs.form0.validate();
    },
    resetValidation() {
      return this.$refs.form0.resetValidation();
    },
    // Lien vers une PM
    lienPersonneMorale(idPersonneMorale) {
      const route = this.$liens().personneMorale(idPersonneMorale);
      if (this.$auth.mayNavigateTo(route)) {
        this.$router.push(route);
      }
    },
    // Lien vers une PP
    lienPersonnePhysique(id) {
      const route = this.$liens().personnePhysique(id);
      if (this.$auth.mayNavigateTo(route)) {
        this.$router.push(route);
      }
    },
    formatDate(isoDate) {
      if (!isoDate) return null;

      return moment(isoDate).format('DD/MM/YYYY');
    },
    getInternational,
  },
};
</script>
